export default __webpack_public_path__ + "static/media/myjourney-greentree-fruitnutflower.f3798773.svg";